import { Button as ChakraButton } from '@chakra-ui/react';

/**
 * DatLynk Button — thin wrapper over Chakra UI v3 Button.
 * Preserves the same prop API used throughout the codebase:
 *   variant: 'primary' | 'secondary' | 'outline' | 'ghost'
 *   size:    'small' | 'medium' | 'large'
 *   loading, disabled, type, ariaLabel, onClick
 */
const Button = ({
  variant = 'primary',
  size = 'medium',
  children,
  disabled = false,
  loading = false,
  onClick,
  type = 'button',
  className,
  ariaLabel,
  style,
  ...props
}) => {
  // Map legacy variant names → Chakra v3 variants
  const chakraVariant =
    variant === 'cta'       ? 'solid'   :
    variant === 'primary'   ? 'solid'   :
    variant === 'secondary' ? 'outline' :
    variant === 'outline'   ? 'outline' :
    variant === 'ghost'     ? 'ghost'   : 'solid';

  // Map legacy size names → Chakra v3 sizes
  const chakraSize =
    size === 'large'  ? 'lg' :
    size === 'small'  ? 'sm' : 'md';

  const colorPalette = 'brand';

  const ctaProps = variant === 'cta' ? {
    bg: 'brand.primary',
    color: 'white',
    fontWeight: '800',
    boxShadow: 'shadows.cta',
    _hover: {
      bg: 'brand.500',
      boxShadow: '0 0 40px rgba(34, 211, 238, 0.4)',
      transform: 'translateY(-2px)'
    },
    _active: {
      bg: 'brand.600',
      transform: 'translateY(0)'
    }
  } : {};

  return (
    <ChakraButton
      type={type}
      variant={chakraVariant}
      size={chakraSize}
      colorPalette={colorPalette}
      disabled={disabled || loading}
      loading={loading}
      loadingText="Loading..."
      onClick={onClick}
      aria-label={ariaLabel}
      className={className}
      style={style}
      fontFamily="body"
      fontWeight="600"
      borderRadius="md"
      transition="all 200ms cubic-bezier(0.4, 0, 0.2, 1)"
      {...ctaProps}
      {...props}
    >
      {children}
    </ChakraButton>
  );
};

export default Button;
